<template>
  <div class="logo" :class="{ collapse: adminCollapse }">
    <span>UMS</span>
    <span class="label">综合管理平台</span>
  </div>
</template>

<script>
export default {
  props: {
    adminCollapse: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./logo.scss");
</style>